import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractIncidentDataSource } from '@types-custom/models/ui/modal-roadworks-model';
import { Subject, map, Observable, BehaviorSubject  } from 'rxjs';
import environment from "@citizen-env/environment.prod";
import { formatInTimeZone } from 'date-fns-tz';

@Injectable({
  providedIn: 'root'
})
export class IncidentsService implements AbstractIncidentDataSource{

  incidentFilterNotifier$ = new Subject<any>();
  filter$ = new BehaviorSubject<any>(undefined);

  defaultDateStart: any;
  defaultDateEnd:any;

  constructor(
    private httpClient: HttpClient,
    @Inject('environment') private environment: any
  ) {
    this.formatSpainDate()
    }

  formatSpainDate(){
    const fechaActualUTC  = new Date();
    this.defaultDateStart = formatInTimeZone(fechaActualUTC, 'Europe/Madrid', "yyyy-MM-dd'T'00:00:00.000'Z'");
    this.defaultDateEnd = formatInTimeZone(fechaActualUTC, 'Europe/Madrid', "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'")
  }


  getIncidentGeoJSON(queryFilters: string = `&beginDate=${this.defaultDateStart}&endDate=${this.defaultDateEnd}`+'&situationIds=334&situationIds=335&situationIds=333&stateIds=331') : Observable<any> {

    //return this.httpClient.get<any>('assets/mock/situations.json');
      return this.httpClient.get<any>(
      `${this.environment.incidentUrl}/incidents/format-geo-json?recordsPerPage=1000&page=0${queryFilters}`,
    );

  }

  getIncidentsByHour(): Observable<any> {
    return this.httpClient.get<any>(`${this.environment.incidentUrl}/incidents/last-incidents`)
    //return this.httpClient.get<any>('assets/mock/incidentsByHour.json')
    .pipe(
      map((response) => this.formatData(response))
    );

  }

  getFiltersCategory(): Observable<any>{
    return this.httpClient.get<any>(`${this.environment.incidentUrl}/incident-categories/Categoria/list`);
  }

  getfiltersIncidents(): Observable<any>{
    return this.httpClient.get<any>(`${this.environment.incidentUrl}/incident-categories/category-code/TipoIncidente`);
  }

  getDataModal(incidentId: string): Observable<any> {
    return this.httpClient.get<any[]>(`${this.environment.incidentUrl}/incident/${incidentId}`);
  }



  formatData(data:[]){
    const dataFormatted:any = {}
    data.forEach((item:any) => {
      item['graph']?.forEach((hourDetail:any) => {
        dataFormatted[hourDetail['hour']] =  {...dataFormatted[hourDetail['hour']], hour: hourDetail['hour'], [item['situationTypeName']]: hourDetail['count']}
      })
    })
    return Object.values(dataFormatted).sort((hourDetailA:any, hourDetailB:any) => {
      const hourA = parseInt(hourDetailA.hour.split(':')[0])
      const hourB = parseInt(hourDetailB.hour.split(':')[0])
      return hourA - hourB
    })
  }

  public setFilter(filter: any): void {
    this.filter$.next(filter);
  }

  public getFilter() {
    return this.filter$;
  }
}
